import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit3-conclusion',
  templateUrl: './unit3-conclusion.component.html',
  styleUrls: ['./unit3-conclusion.component.css']
})
export class Unit3ConclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
